import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'TitleSection' })((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 56,
        maxWidth: 1065,
        marginLeft: 'auto',
        marginRight: 'auto',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            gap: 40
        }
    },
    title: {
        opacity: 0,
        transition: 'opacity 0.6s'
    },
    buttons: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            width: '100%',
            flexDirection: 'column'
        }
    },
    button: {
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            width: '100%'
        }
    }
}));
